import { CommonService } from '@business/services';
import { Endpoint } from '../endpoint';
import { CompanyResponse, CompanyId } from '@business/entities/companies';

export function fetchCompanies() {
  return Endpoint.get<CompanyResponse[]>(`@makh/companies`);
}

export function fetchCompany(id: CompanyId) {
  return Endpoint.get<CompanyResponse>(`@makh/companies/company/${id}`);
}

export function createCompany(company: Partial<CompanyResponse>) {
  return Endpoint.post<CompanyResponse>(`@makh/companies/create`, { data: { ...company } });
}

// export function updateCompany(id: CompanyId, company: Partial<CompanyResponse>) {
//   return Endpoint.patch<CompanyResponse>(`@makh/companies/${id}`, { data: { ...company } });
// }

export function updateCompany(id: CompanyId, company: Partial<CompanyResponse>) {
  const formData = CommonService.toFormData(company);
  return Endpoint.post<CompanyResponse>(`@makh/companies/update/${id}`, { formData, hasFiles: true });
}

export function deleteCompany(companyId: CompanyId) {
  return Endpoint.delete<void>(`@makh/companies/${companyId}`);
}

export function updateCompanyContent(id: CompanyId, company: Partial<CompanyResponse>) {
  return Endpoint.patch<CompanyResponse>(`@makh/companies/content/${id}`, { data: { ...company } });
}
